import { db } from './firebase';
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  Timestamp,
} from 'firebase/firestore';

const COLLECTION = 'preRegisteredVolunteers';

/**
 * Add a volunteer directly (org-admin action) without them creating an account.
 * They receive email-only reminders until they sign up and claim the record —
 * SMS/push stay opt-in-only and are never set here.
 */
export const createPreRegisteredVolunteer = async (uid, { displayName, email, phone, organizationId, organizationName }) => {
  const docRef = await addDoc(collection(db, COLLECTION), {
    displayName,
    email,
    phone: phone || null,
    organizationId,
    organizationName,
    status: 'invited',
    addedBy: uid,
    createdAt: Timestamp.now(),
  });
  return docRef.id;
};

export const getPreRegisteredVolunteersByOrg = async (organizationId, status = 'invited') => {
  const q = query(
    collection(db, COLLECTION),
    where('organizationId', '==', organizationId),
    where('status', '==', status)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const deletePreRegisteredVolunteer = async (preRegId) => {
  await deleteDoc(doc(db, COLLECTION, preRegId));
};

/**
 * Platform-admin only: all unclaimed pre-registered volunteers across every organization.
 */
export const getAllPreRegisteredVolunteers = async (status = 'invited') => {
  const q = query(collection(db, COLLECTION), where('status', '==', status));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};
